// extracted by css-extract-rspack-plugin
export default {"popoverPaper":"OptionsPopover_popoverPaper__ZlfPO"};